






















import { Mobile } from "@/mixins/mobile";
import { LineItem } from "@/models/order/order";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import PriceSurchargeModal from "@/components/elements/modal/PriceSurchargeModal.vue";

@Component({
  components: {
    PriceSurchargeModal,
  }
})
export default class CartFooter extends mixins(Mobile) {
  @Prop() items!: LineItem[];
  protected showSurchargeModal = false;

  protected handleContinueButtonClick(): void {
    this.showSurchargeModal = true;
  }

  beforeDestroy(): void {
    this.showSurchargeModal = false;
  }
  protected closeModal(): void {
    this.showSurchargeModal = false;
    this.$router.push('/checkout');
  }
}
